import { Paper } from "@mui/material";
import styled from "@emotion/styled";

export const SkeletonCardWrapper = styled(Paper)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	padding: "16px",
	gap: "24px",
	backgroundColor: theme.project.colors.allColors.hex.grayscale.gray50
}));

export const SkeletonBody = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: "8px"
});

export const SkeletonItems = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "space-between",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column"
	}
}));
